// export const serverUrl = "http://65.1.191.108:8080/"; // MYSQL

import { environment } from "src/environments/environment";

// export const serverUrl = 'http://192.168.15.37:8080/';
export const serverUrl = environment.REGISTRATION_URL;
 // YOGESH
// export const serverUrl = "http://192.168.0.198:38085/"; // YOGESH
// export const serverUrl = "http://10.0.0.132:9009/"; // CK Airtel
// export const serverUrl = "http://172.20.10.11:8080/"; // CK iPhone
// export const serverUrl = "http://172.20.10.14:8080/"; // Om iPhone
// export const serverUrl = "https://demoilmsservice.mhada.gov.in/"; // Oracle
// export const serverUrl = "https://uatilmsservice.mhada.gov.in/"; // Oracle UAT
//export const serverUrl = "https://lotterybackendprod.mhada.gov.in/"; // Production
// export const serverUrl = "http://65.1.196.115:8085/"; // Oracle
// ILMS(CK_IPHONE)_1409_1207PM
